<template>
  <master-main
    :exportProperties="{
      pdf: {
        filename: `${$t('common_words.scale_configuration')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('common_words.scale_configuration')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-scale-configuration
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import EditCreate from './EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import ScaleConfigurationTable from './scale-configuration-table';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'scales/configurations';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ScaleConfigurationTable().tableColumns],
        model: 'scale_configuration',
        effectTags: 'dark',
        widthColumnStatus: 160,
        defaultSort: { prop: 'id', order: 'descending' },
      };
    },

    dateToday() {
      return getDateToday();
    },
  },
};
</script>
